import './errorScreen.scss';
import Button from 'components/commons/buttons/button/Button';
import { useTranslate } from 'context/languageContext';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';
import UseSEO from 'hooks/useSEO/UseSEO';
import { useDispatch } from 'react-redux';
import { updateShowLoading } from 'redux/slices/contextualSlice';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { ReactComponent as Ic_Error } from 'resources/icons/error_500.svg';
import { ReactComponent as Ic_Error_501 } from 'resources/icons/Ic_close_circle_fill_red.svg';
import { ReactComponent as Ic_logo } from 'resources/icons/Logo_largo.svg';
import { ReactComponent as Ic_check } from 'resources/icons/Ic_check_circle_fill_240.svg';
import { useEffect } from 'react';
import { updateShowSubMenu } from 'redux/slices/subMenuSlices';
import { scrollTop } from 'utils/utils';

interface IErrorScreen {
  errorCode: number;
  message?: string;
}
export default function ErrorScreen({ errorCode, message }: IErrorScreen) {
  const dispatch = useDispatch();
  const t = useTranslate();
  const navigate = useNavigate();
  const [generateUrl] = UseSEO();
  const [type, setType] = useState<any>({ code: null, title: '' });

  const getStatus = () => {
    const msg = message ? message : t('lb_error404_no_encontrada');
    switch (errorCode) {
      case 404:
        setType({ code: 404, title: message ? message : msg });
        break;
      case 200:
        setType({ code: 200, title: message });
        break;
      default:
        setType({ code: 500, title: message || t('lb_error500') });
        break;
    }
  };

  useEffect(() => {
    scrollTop();
    getStatus();
    dispatch(updateShowLoading(false));
  }, []);

  return (
    <main className='error404Screen'>
      <section className='not-found-container'>
        {errorCode === 500 && <SvgIcon Icon={Ic_logo} className='logo-emt-error' />}
        {errorCode === 404 && <SvgIcon Icon={Ic_Error} />}
        {errorCode === 501 && <SvgIcon Icon={Ic_Error_501} />}
        {errorCode === 200 && <SvgIcon Icon={Ic_check} />}
        {errorCode === 500 && <h1 className='not-found-code'>{type?.code}</h1>}
        <h1 className='not-found-title'>{type.title}</h1>
        {(errorCode === 400 || errorCode === 200 || errorCode === 404) && (
          <Button
            className='not-found-btn'
            onClick={() => {
              //desactivamos el menú al volver a la página de inicio para evitar errores de ejecución
              dispatch(updateShowSubMenu(false));
              navigate(generateUrl(RUTAS_GENERALES_MUL2.home));
            }}
          >
            {t('lb_volver_al_home')}
          </Button>
        )}
      </section>
    </main>
  );
}
